import React from 'react';

import { Box } from '@chakra-ui/react';

export const CardDescription = (props) => (
  <Box mt={3} overflowWrap="break-word" h="4.5rem" {...props} />
);
